var map = {
	"./ARC.json": 7416,
	"./ARC_LONG.json": 9011,
	"./BIORE_GIF.json": 5742,
	"./BLOB.json": 4163,
	"./BLOB_LONG.json": 3862,
	"./BUZZ.json": 53,
	"./CARNIVAL.json": 1814,
	"./CHANGI.json": 356,
	"./EXO.json": 7138,
	"./FLOATINGMAN.json": 1622,
	"./GOLDFISH.json": 520,
	"./INGOTS.json": 9344,
	"./MALING.json": 3170,
	"./MEEP_LONG.json": 8454,
	"./MOONCAKE_LONG.json": 7352,
	"./PICKERING.json": 4042,
	"./SKILL_FEATURE.json": 9424,
	"./SUISAI_GIF.json": 951,
	"./TEMASEKTRUST.json": 1436,
	"./THEOTHERLIFE.json": 6729,
	"./TOLLOGO.json": 8816,
	"./TOLLOGO2.json": 3274,
	"./TOL_512.json": 6808,
	"./TOWERBOX.json": 518
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4035;